import type { FormEvent } from "react";
import { ArrowUp } from "lucide-react";
import { Button } from "@/components/ui/button";

function ChipIcon() {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M3.33594 4.0026C3.33594 3.82579 3.40618 3.65622 3.5312 3.5312C3.65622 3.40618 3.82579 3.33594 4.0026 3.33594H12.0026C12.1794 3.33594 12.349 3.40618 12.474 3.5312C12.599 3.65622 12.6693 3.82579 12.6693 4.0026V12.0026C12.6693 12.1794 12.599 12.349 12.474 12.474C12.349 12.599 12.1794 12.6693 12.0026 12.6693H4.0026C3.82579 12.6693 3.65622 12.599 3.5312 12.474C3.40618 12.349 3.33594 12.1794 3.33594 12.0026V4.0026Z"
				stroke="currentColor"
				strokeWidth="1.2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6 6H10V10H6V6Z"
				stroke="currentColor"
				strokeWidth="1.2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2 6.66406H3.33333"
				stroke="currentColor"
				strokeWidth="1.2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2 9.33594H3.33333"
				stroke="currentColor"
				strokeWidth="1.2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6.66406 2V3.33333"
				stroke="currentColor"
				strokeWidth="1.2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9.33594 2V3.33333"
				stroke="currentColor"
				strokeWidth="1.2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M13.9974 6.66406H12.6641"
				stroke="currentColor"
				strokeWidth="1.2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M13.9974 9.33594H12.6641"
				stroke="currentColor"
				strokeWidth="1.2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9.33594 13.9974V12.6641"
				stroke="currentColor"
				strokeWidth="1.2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6.66406 13.9974V12.6641"
				stroke="currentColor"
				strokeWidth="1.2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

interface WorkspaceChatComposerProps {
	value: string;
	onChange: (value: string) => void;
	onSubmit: (e: FormEvent) => void;
	placeholder: string;
	/** Nothing can be typed or sent, e.g. while a deletion waits for its buttons. */
	disabled?: boolean;
}

export function WorkspaceChatComposer({
	value,
	onChange,
	onSubmit,
	placeholder,
	disabled,
}: WorkspaceChatComposerProps) {
	return (
		<div className="px-6 pb-4 pt-1">
			<form onSubmit={onSubmit}>
				<div className="relative rounded-2xl bg-bg-surface border border-border-control shadow-lg focus-within:ring-2 focus-within:ring-focus-ring focus-within:ring-offset-2 focus-within:ring-offset-bg-surface">
					<input
						type="text"
						value={value}
						onChange={(e) => onChange(e.target.value)}
						placeholder={placeholder}
						disabled={disabled}
						className="w-full bg-transparent text-text-primary placeholder:text-text-tertiary text-sm px-4 py-3.5 pr-24 focus:outline-none disabled:cursor-not-allowed"
					/>
					<div className="absolute right-2 top-1/2 bg-bg-surface rounded-full p-1 -translate-y-1/2 flex items-center gap-1">
						<Button
							type="button"
							variant="ghost"
							size="icon-sm"
							className="rounded-full"
						>
							<ChipIcon />
						</Button>
						<Button
							type="submit"
							size="icon-sm"
							disabled={disabled || !value.trim()}
							className="rounded-full"
						>
							<ArrowUp size={16} strokeWidth={2.5} />
						</Button>
					</div>
				</div>
			</form>
		</div>
	);
}
